navigator.sayswho = (function () {
  var ua = "";
  if (navigator.userAgentData) {
    ua = JSON.stringify(navigator.userAgentData);
  } else {
    ua = navigator.userAgent;
  }
  var tem;
  var M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return "IE " + (tem[1] || "");
  }
  if (M[1] === "Chrome") {
    tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
    if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
  if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
  return M.join(" ");
})();

if (!Function.prototype.bind) {
  Function.prototype.bind = function (oThis) {
    if (typeof this !== "function") {
      // closest thing possible to the ECMAScript 5
      // internal IsCallable function
      throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");
    }

    var aArgs = Array.prototype.slice.call(arguments, 1),
      fToBind = this,
      fNOP = function () {},
      fBound = function () {
        return fToBind.apply(this instanceof fNOP && oThis ? this : oThis, aArgs.concat(Array.prototype.slice.call(arguments)));
      };

    fNOP.prototype = this.prototype;
    fBound.prototype = new fNOP();

    return fBound;
  };
}

if (!Uint8Array.prototype.toBase64string) {
  Uint8Array.prototype.toBase64string = function () {
    var arr = this;
    var binary = "";
    for (var i = 0; i < arr.byteLength; i++) {
      binary += String.fromCharCode(arr[i]);
    }
    return window.btoa(binary);
  };
}

if (!Array.prototype.naiveForFilter) {
  Array.prototype.naiveForFilter = function (f) {
    "use strict";
    var results = [];
    var len = this.length;
    for (var i = 0; i < len; i++) {
      if (f(this[i])) {
        results.push(this[i]);
      }
    }
    return results;
  };
}

if (!Array.prototype.asyncForEach) {
  Array.prototype.asyncForEach = async function (callback) {
    var array = this;
    var len = array.length;
    for (let index = 0; index < len; index++) {
      await callback(array[index], index, array);
    }
  };
}

// if (!Array.prototype.groupByAndSum) {
//   /**
//    * @function
//    * @name Array#groupByAndSum
//    * @param {string} sumProp
//    * @param {...string} groupingProps
//    * @returns {Array}
//    */
//   Array.prototype.groupByAndSum = function (sumProp, ...groupingProps) {
//     var clone = this.slice();
//     if (!sumProp || sumProp.length == 0 || !groupingProps || groupingProps.length == 0) return clone;
//     var newArr = [];
//     var sumArr = [];
//     if (sumProp instanceof Array) sumArr.push(...sumProp);
//     else sumArr.push(sumProp);
//     var cnt = clone.length;
//     for (var r = cnt - 1; r >= 0; r--) {
//       var lastEl = clone[r];
//       var foundIdx = newArr.findIndex((i) => groupingProps.every((prop) => (i[prop] instanceof Date ? i[prop].getTime() === lastEl[prop].getTime() : i[prop] === lastEl[prop])));
//       if (r % 1000 == 0) console.log(r)
//       //SLOW //return groupingProps.every(prop =>  JSON.stringify(i[prop]) === JSON.stringify(lastEl[prop]));
//       //SLOW //return groupingProps.every(p => Object.byString(i, p) === Object.byString(lastEl, p));
//       if (foundIdx == -1) {
//         foundIdx = newArr.push(Object.assign({}, lastEl)) - 1; //????
//       } else {
//         sumArr.forEach((p) => {
//           newArr[foundIdx][p] += lastEl[p];
//         });
//       }
//       clone.splice(r, 1);
//     }
//     //res.push(...newArr); return res;
//     return newArr;
//   };
// }

// if (!Array.prototype.groupByAndAverageSum) {
//   /**
//    * @function
//    * @name Array#groupByAndAverage
//    * @param {string} sumProp
//    * @param {...string} groupingProps
//    * @returns {Array}
//    */
//   Array.prototype.groupByAndAverageSum = function (sumProp, rangeProp, ...groupingProps) {
//     var clone = this.slice();
//     if (!sumProp || sumProp.length == 0 || !rangeProp || !groupingProps || groupingProps.length == 0) return clone;

//     var range = clone.map((i) => Object.byString(i, rangeProp));
//     var divider = 1;
//     if (range[0] instanceof Date) {
//       var maxDate = new Date(Math.max.apply(null, range));
//       var minDate = new Date(Math.min.apply(null, range));
//       var diffTime = Math.abs(maxDate - minDate);
//       divider = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
//     } else {
//       divider = Math.max(range) - Math.min(range);
//     }
//     var newArr = [];
//     var sumArr = [];
//     if (sumProp instanceof Array) sumArr.push(...sumProp);
//     else sumArr.push(sumProp);

//     var cnt = clone.length;
//     for (var r = cnt - 1; r >= 0; r--) {
//       var lastEl = clone[r];
//       var foundIdx = newArr.findIndex((i) => groupingProps.every((prop) => (i[prop] instanceof Date ? i[prop].getTime() === lastEl[prop].getTime() : i[prop] === lastEl[prop])));

//       //SLOW //return groupingProps.every(prop =>  JSON.stringify(i[prop]) === JSON.stringify(lastEl[prop]));
//       //SLOW //return groupingProps.every(p => Object.byString(i, p) === Object.byString(lastEl, p));
//       if (foundIdx == -1) {
//         foundIdx = newArr.push(lastEl) - 1;
//       } else {
//         sumArr.forEach((p) => {
//           newArr[foundIdx][p] += lastEl[p];
//         });
//       }
//       clone.splice(r, 1);
//     }
//     newArr.forEach((e) => {
//       sumArr.forEach((p) => {
//         e[p] /= divider;
//       });
//     });

//     //this.push(...newArr); return this;
//     return newArr;
//   };
// }

if (!Array.prototype.groupByAndSum) {
  /**
   * @function
   * @name Array#groupByAndSum
   * @param {string} sumProp
   * @param {...string} groupingProps
   * @returns {Array}
   */
  Array.prototype.groupByAndSum = function (sumProp, ...groupingProps) {
    var clone = this.slice();
    if (!sumProp || sumProp.length == 0 || !groupingProps || groupingProps.length == 0) return clone;
    var newO = {};
    var sumArr = [];
    if (sumProp instanceof Array) sumArr.push(...sumProp);
    else sumArr.push(sumProp);
    var cnt = clone.length;
    for (var r = cnt - 1; r >= 0; r--) {
      var lastEl = clone[r];
      var ids = [];
      groupingProps.forEach((prop) => {
        ids.push(JSON.stringify(Object.byString(lastEl, prop)));
      });
      var id = ids.join();

      if (!newO[id]) {
        newO[id] = Object.assign({}, lastEl);
      } else {
        sumArr.forEach((p) => {
          newO[id][p] += lastEl[p]; //Object.byString(lastEl, p);
        });
      }
    }
    return Object.values(newO);
  };
}

if (!Array.prototype.groupByAndAverageSum) {
  /**
   * @function
   * @name Array#groupByAndAverage
   * @param {string} sumProp
   * @param {...string} groupingProps
   * @returns {Array}
   */
  Array.prototype.groupByAndAverageSum = function (sumProp, rangeProp, ...groupingProps) {
    var clone = this.slice();
    if (!sumProp || sumProp.length == 0 || !rangeProp || !groupingProps || groupingProps.length == 0) return clone;

    var range = clone.map((i) => Object.byString(i, rangeProp));
    var divider = 1;
    if (range[0] instanceof Date) {
      var maxDate = new Date(Math.max.apply(null, range));
      var minDate = new Date(Math.min.apply(null, range));
      var diffTime = Math.abs(maxDate - minDate);
      divider = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    } else {
      divider = Math.max(range) - Math.min(range);
    }
    var newArr = [];
    var sumArr = [];
    if (sumProp instanceof Array) sumArr.push(...sumProp);
    else sumArr.push(sumProp);
    var newO = {};
    var cnt = clone.length;
    for (var r = cnt - 1; r >= 0; r--) {
      var lastEl = clone[r];
      var ids = [];
      groupingProps.forEach((prop) => {
        ids.push(JSON.stringify(Object.byString(lastEl, prop)));
      });
      var id = ids.join();
      if (!newO[id]) {
        newO[id] = Object.assign({}, lastEl);
      } else {
        sumArr.forEach((p) => {
          newO[id][p] += lastEl[p];
        });
      }
    }
    newArr = Object.values(newO);
    newArr.forEach((e) => {
      sumArr.forEach((p) => {
        e[p] /= divider;
      });
    });
    return newArr;
  };
}

// Object.defineProperty(Array.prototype, "groupByAndSum", {
//     value: function(sumProp, ...groupingProps) {
//         var cnt = this.length;
//         for(var r = cnt-1; r > 0; r--) {
//             var lastEl = this[r];
//             var found = this.find(function(i) {
//                 return groupingProps.every(prop => i[prop] == lastEl[prop] );
//             });
//             if(found && this.indexOf(found) != r) {
//                 found[sumProp] += lastEl[sumProp];
//                 this.splice(r, 1);
//             }
//         }
//     }
// });

if (!Array.prototype.isElementUnique) {
  Array.prototype.isElementUnique = function (e) {
    return (
      this.filter(function (ee) {
        return ee == e;
      }).length == 1
    );
  };
}

if (!String.prototype.toTitleCase) {
  String.prototype.toTitleCase = function () {
    var splitStr = this.toLowerCase().split(" ");
    for (var i = 0; i < splitStr.length; i++) {
      // You do not need to check if i is larger than splitStr length, as your for does that for you
      // Assign it back to the array
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    // Directly return the joined string
    return splitStr.join(" ");
  };
}

if (!String.prototype.endsWith) {
  String.prototype.endsWith = function (searchString, position) {
    var subjectString = this.toString();
    if (typeof position !== "number" || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
      position = subjectString.length;
    }
    position -= searchString.length;
    var lastIndex = subjectString.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
  };
}

if (!String.prototype.replaceAll) {
  String.prototype.replaceAll = function (search, replacement) {
    return this.replace(new RegExp(search.replace(/([.*+?^=!:${}()|[]\/\\])/g, "\\$1"), "g"), replacement);
  };
}

if (!String.prototype.contains) {
  String.prototype.contains = function (str) {
    return this.indexOf(str) != -1;
  };
}
if (!String.prototype.camelize) {
  String.prototype.camelize = function () {
    var arr = this.split(" ");
    var capital = arr.map(function (item) {
      return item.charAt(0).toUpperCase() + item.slice(1).toLowerCase();
    });
    var capitalString = capital.join("");
    return capitalString;
  };
}

// if (!Array.prototype.splitToChunks) {
//   Array.prototype.splitToChunks = function (parts) {
//     var clone = this.slice();
//     let result = [];
//     for (let i = parts; i > 0; i--) {
//       result.push(clone.splice(0, Math.ceil(clone.length / i)));
//     }
//     return result;
//   }
// }
if (!Array.prototype.splitToChunks) {
  Array.prototype.splitToChunks = function (len) {
    var clone = this.slice();
    var chunks = [],
      i = 0,
      n = clone.length;
    while (i < n) {
      chunks.push(clone.slice(i, (i += len)));
    }
    return chunks;
  };
}

if (!Array.prototype.sum) {
  Array.prototype.sum = function () {
    return this.reduce(function (a, b) {
      return a + b;
    }, 0);
  };
}

if (!Array.prototype.unique) {
  Array.prototype.unique = function () {
    var o = {};
    var arr = this;
    arr.forEach((e) => {
      if (e != null && e != undefined) {
        o["_" + JSON.stringify(e).replace(" ", "_")] = e;
      }
    });
    return Object.values(o);
  };
}

if (!Array.prototype.unique2) {
  Array.prototype.unique2 = function () {
    if (!this[0] || typeof this[0] === "string" || typeof this[0] === "number" || this[0] instanceof Date) {
      return this.filter(function (value, index, self) {
        return self.indexOf(value) == index;
      });
    } else {
      var cnt = this.length;
      for (var r = cnt - 1; r > 0; r--) {
        var lastEl = this[r];
        var found = this.find(function (value) {
          var aProps = Object.getOwnPropertyNames(lastEl);
          var bProps = Object.getOwnPropertyNames(value);
          if (aProps.length != bProps.length) {
            return false;
          }
          for (var i = 0; i < aProps.length; i++) {
            var propName = aProps[i];
            if (lastEl[propName] !== value[propName]) {
              return false;
            }
          }
          return true;
        });
        if (found && this.indexOf(found) != r) {
          this.splice(r, 1);
        }
      }
      return this;
    }
  };
}

if (!Array.prototype.getLast) {
  Array.prototype.getLast = function (num) {
    return this.slice(Math.max(this.length - num, 0));
  };
}

if (!Array.prototype.sortBy) {
  Array.prototype.sortBy = function (prop) {
    if (!prop || prop.length == 0) {
      return this;
    }
    prop = prop.split(".");
    var len = prop.length;

    this.sort(function (a, b) {
      var i = 0;
      while (i < len) {
        a = a[prop[i]];
        b = b[prop[i]];
        i++;
      }
      if (a < b) {
        return -1;
      } else if (a > b) {
        return 1;
      } else {
        return 0;
      }
    });
    return this;
  };
}

if (!Array.prototype.sortByDesc) {
  Array.prototype.sortByDesc = function (prop) {
    if (!prop || prop.length == 0) {
      return this;
    }
    prop = prop.split(".");
    var len = prop.length;

    this.sort(function (a, b) {
      var i = 0;
      while (i < len) {
        a = a[prop[i]];
        b = b[prop[i]];
        i++;
      }
      if (a < b) {
        return 1;
      } else if (a > b) {
        return -1;
      } else {
        return 0;
      }
    });
    return this;
  };
}

if (!Number.prototype.lpad) {
  Number.prototype.lpad = function (size) {
    var s = String(this);
    while (s.length < (size || 2)) {
      s = "0" + s;
    }
    return s;
  };
}

if (!Number.prototype.roundTo) {
  Number.prototype.roundTo = function (digits) {
    //много тъп краден код...
    var negative = false;
    var n = this;
    if (digits === undefined) {
      digits = 0;
    }
    if (n < 0) {
      negative = true;
      n = n * -1;
    }
    var multiplicator = Math.pow(10, digits);
    n = parseFloat((n * multiplicator).toFixed(11));
    n = (Math.round(n) / multiplicator).toFixed(digits);
    if (negative) {
      n = (n * -1).toFixed(digits);
    }
    return Number(n);
  };
}

if (!Date.prototype.createArray) {
  Date.prototype.createArray = function (stopDate) {
    var dateArray = new Array();
    var currentDate = this;
    while (currentDate < stopDate) {
      dateArray.push(new Date(currentDate));
      currentDate = currentDate.addDays(1);
    }
    dateArray.push(stopDate);
    return dateArray;
  };
}

if (!Date.TremolFpFormat) {
  Date.TremolFpFormat = "dd-MM-yyyy HH:mm:ss";
}

if (!Date.prototype.getMonday) {
  Date.prototype.getMonday = function () {
    var day = this.getDay();
    var diff = this.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
    return new Date(new Date(this.getTime()).setDate(diff));
  };
}

if (!Date.prototype.getWeekOfMonth) {
  Date.prototype.getWeekOfMonth = function () {
    var adjustedDate = this.getDate() + this.getDay();
    var prefixes = ["0", "1", "2", "3", "4", "5"];
    return parseInt(prefixes[0 | (adjustedDate / 7)]) + 1;
  };
}

if (!Date.prototype.getDateWithoutTime) {
  Date.prototype.getDateWithoutTime = function () {
    return new Date(this.getFullYear(), this.getMonth(), this.getDate(), 0, 0, 0, 0);
  };
}

if (!Date.prototype.getDate235959) {
  Date.prototype.getDate235959 = function () {
    return new Date(this.getFullYear(), this.getMonth(), this.getDate(), 23, 59, 59, 999);
  };
}

if (!Date.prototype.getFirstDayOfMonth) {
  Date.prototype.getFirstDayOfMonth = function () {
    return new Date(this.getFullYear(), this.getMonth(), 1, 0, 0, 0, 0);
  };
}

if (!Date.prototype.toTremolFpString) {
  Date.prototype.toTremolFpString = function () {
    var d = this.getDate().lpad(2);
    var M = (this.getMonth() + 1).lpad(2);
    var y = this.getFullYear().lpad(4);
    var h = this.getHours().lpad(2);
    var m = this.getMinutes().lpad(2);
    var s = this.getSeconds().lpad(2);
    return d + "." + M + "." + y + " " + h + ":" + m + ":" + s;
  };
}

if (!Date.prototype.toTremolFpStringShort) {
  Date.prototype.toTremolFpStringShort = function () {
    var d = this.getDate().lpad(2);
    var M = (this.getMonth() + 1).lpad(2);
    var y = this.getFullYear().lpad(4);
    return d + "." + M + "." + y + " г.";
  };
}

if (!Date.prototype.toStringWithFormat) {
  Date.prototype.toStringWithFormat = function (format) {
    var f = format;
    var d = this.getDate();
    var M = this.getMonth() + 1;
    var y = this.getFullYear();
    var h = this.getHours();
    var m = this.getMinutes();
    var s = this.getSeconds();
    var n = this.getMilliseconds();
    f = f.replace("dd", d.lpad(2));
    f = f.replace("d", d);
    f = f.replace("MM", M.lpad(2));
    f = f.replace("M", M);
    f = f.replace("YYYY", y.lpad(4));
    f = f.replace("yyyy", y.lpad(4));
    f = f.replace("YY", (y - 2000).lpad(2));
    f = f.replace("yy", (y - 2000).lpad(2));
    f = f.replace("HH", h.lpad(2));
    f = f.replace("hh", h.lpad(2));
    f = f.replace("mm", m.lpad(2));
    f = f.replace("m", m);
    f = f.replace("ss", s.lpad(2));
    f = f.replace("s", s);
    f = f.replace("nnn", n.lpad(3));
    return f;
  };
}

if (!Date.prototype.addHours) {
  Date.prototype.addHours = function (h) {
    var date = new Date(this.valueOf());
    date.setTime(this.getTime() + h * 60 * 60 * 1000);
    return date;
  };
}

if (!Date.prototype.addDays) {
  Date.prototype.addDays = function (days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
  };
}

if (!Date.prototype.addYears) {
  Date.prototype.addYears = function (years) {
    var date = new Date(this.valueOf());
    date.setFullYear(date.getFullYear() + years);
    return date;
  };
}

if (!Date.prototype.addMonths) {
  Date.prototype.addMonths = function (months) {
    var date = new Date(this.valueOf());
    date.setMonth(date.getMonth() + months);
    return date;
  };
}

if (!Date.prototype.addMinutes) {
  Date.prototype.addMinutes = function (minutes) {
    var date = new Date(this.valueOf());
    date.setMinutes(date.getMinutes() + minutes);
    return date;
  };
}

if (!Date.prototype.addSeconds) {
  Date.prototype.addSeconds = function (seconds) {
    var date = new Date(this.valueOf());
    date.setSeconds(date.getSeconds() + seconds);
    return date;
  };
}

if (!Date.prototype.addMilliseconds) {
  Date.prototype.addMilliseconds = function (milliseconds) {
    var date = new Date(this.valueOf());
    date.setMilliseconds(date.getMilliseconds() + milliseconds);
    return date;
  };
}

if (!Date.prototype.daysDiff) {
  Date.prototype.daysDiff = function (dt) {
    var diffTime = Math.abs(this - dt);
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  };
}

if (!String.prototype.copyToClipboard) {
  String.prototype.copyToClipboard = function () {
    var dummy = document.createElement("textarea");
    // to avoid breaking orgain page when copying more words
    // cant copy when adding below this code
    // dummy.style.display = 'none'
    document.body.appendChild(dummy);
    //Be careful if you use texarea. setAttribute('value', value), which works with "input" does not work with "textarea". – Eduard
    dummy.value = this;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
  };
}

if (!String.prototype.parseDateWithFormat) {
  String.prototype.parseDateWithFormat = function (format) {
    var p = this;
    var f = format;
    var y = 0;
    var M = 0;
    var d = 0;
    var h = 0;
    var m = 0;
    var s = 0;
    var yIx = f.indexOf("yyyy");
    var MIx = f.indexOf("MM");
    var dIx = f.indexOf("dd");
    var hIx = f.indexOf("HH");
    var mIx = f.indexOf("mm");
    var sIx = f.indexOf("ss");
    if (yIx !== -1) {
      y = parseInt(p.substring(yIx, yIx + 4));
    } else {
      yIx = f.indexOf("yy");
      if (yIx !== -1) {
        y = parseInt(p.substring(yIx, yIx + 2));
      }
    }
    if (MIx !== -1) {
      M = parseInt(p.substring(MIx, MIx + 2)) - 1;
    }
    if (dIx !== -1) {
      d = parseInt(p.substring(dIx, dIx + 2));
    }
    if (hIx !== -1) {
      h = parseInt(p.substring(hIx, hIx + 2));
    }
    if (mIx !== -1) {
      m = parseInt(p.substring(mIx, mIx + 2));
    }
    if (sIx !== -1) {
      s = parseInt(p.substring(sIx, sIx + 2));
    }
    return new Date(y, M, d, h, m, s);
  };
}

if (!Object.byString) {
  Object.byString = function (o, s) {
    s = s.replace(/\[(\w+)\]/g, ".$1"); // convert indexes to properties
    s = s.replace(/^\./, ""); // strip a leading dot
    var a = s.split(".");
    var len = a.length;
    for (var i = 0, n = len; i < n; ++i) {
      if (o == null) {
        return null;
      }
      var k = a[i];
      if (k in o) {
        o = o[k];
        // if(i == n && o instanceof Object) {
        //   o = o.toString();
        // }
      } else {
        return null;
      }
    }
    return o;
  };
}

// if (!Object.propertiesToArray) {
//   Object.propertiesToArray = function(obj) {
//     const isObject = (val) => typeof val === "object" && !Array.isArray(val);
//     const addDelimiter = (a, b) => (a ? `${a}.${b}` : b);
//     const paths = (obj = {}, head = "") => {
//       return Object.entries(obj).reduce((product, [key, value]) => {
//         let fullPath = addDelimiter(head, key);
//         var rr = isObject(value) ? product.concat(paths(value, fullPath)) : product.concat(fullPath);
//         return Object.byString(value, rr);
//       }, []);
//     };
//     return paths(obj);
//   };
// }

if (!Object.setNestedProp) {
  Object.setNestedProp = function (o, s, val) {
    s = s.replace(/\[(\w+)\]/g, ".$1"); // convert indexes to properties
    s = s.replace(/^\./, ""); // strip a leading dot
    var a = s.split(".");
    for (var i = 0, n = a.length; i < n; ++i) {
      var k = a[i];
      if (k in o) {
        o = o[k];
      } else {
        return;
      }
    }
    o = val;
    return o;
  };
}

if (!Array.extendByProp) {
  Array.extendByProp = function (arr, ...groupingPropNames) {
    if (!(arr instanceof Array)) {
      var o = [];
      o.push(arr);
      arr = o;
    }
    var gn = groupingPropNames[0];
    var gnNext = groupingPropNames.slice(1, gn.length - 1);
    gnNext.forEach(function (item, idx) {
      gnNext[idx] = gn + "_" + item;
    });
    var results = [];
    for (var c = 0; c < arr.length; c++) {
      for (var i = 0; i < arr[c][gn].length; i++) {
        var so = Object.assign({}, arr[c]);
        var sub = so[gn][i];
        for (var key in sub) {
          if (key != gn) {
            so[gn + "_" + key] = sub[key];
          } else {
            so[key] = sub[key];
          }
        }
        if (so) results.push(so);
      }
    }
    if (gnNext.length > 0) return Array.extendByProp(results, gnNext);
    else return results;
  };
}

if (!Math.randomFromInterval) {
  Math.randomFromInterval = function (min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  };
}

if (!JSON.tryParse) {
  JSON.tryParse = function (str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  };
}

// HTMLElement.resizableGrid = function () {
//   var table = this;
//   var row = table.getElementsByTagName("tr")[0],
//     cols = row ? row.children : undefined;
//   if (!cols) return;

//   table.style.overflow = "hidden";

//   var tableHeight = table.offsetHeight;

//   for (var i = 0; i < cols.length; i++) {
//     var div = createDiv(tableHeight);
//     cols[i].appendChild(div);
//     cols[i].style.position = "relative";
//     setListeners(div);
//   }

//   function setListeners(div) {
//     var pageX, curCol, nxtCol, curColWidth, nxtColWidth;

//     div.addEventListener("mousedown", function (e) {
//       curCol = e.target.parentElement;
//       nxtCol = curCol.nextElementSibling;
//       pageX = e.pageX;

//       var padding = paddingDiff(curCol);

//       curColWidth = curCol.offsetWidth - padding;
//       if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding;
//     });

//     div.addEventListener("mouseover", function (e) {
//       e.target.style.borderRight = "2px solid #0000ff";
//     });

//     div.addEventListener("mouseout", function (e) {
//       e.target.style.borderRight = "";
//     });

//     document.addEventListener("mousemove", function (e) {
//       if (curCol) {
//         var diffX = e.pageX - pageX;

//         if (nxtCol) nxtCol.style.width = nxtColWidth - diffX + "px";

//         curCol.style.width = curColWidth + diffX + "px";
//       }
//     });

//     document.addEventListener("mouseup", function () {
//       curCol = undefined;
//       nxtCol = undefined;
//       pageX = undefined;
//       nxtColWidth = undefined;
//       curColWidth = undefined;
//     });
//   }

//   function createDiv(height) {
//     var div = document.createElement("div");
//     div.style.top = 0;
//     div.style.right = 0;
//     div.style.width = "5px";
//     div.style.position = "absolute";
//     div.style.cursor = "col-resize";
//     div.style.userSelect = "none";
//     div.style.height = height + "px";
//     return div;
//   }

//   function paddingDiff(col) {
//     if (getStyleVal(col, "box-sizing") == "border-box") {
//       return 0;
//     }

//     var padLeft = getStyleVal(col, "padding-left");
//     var padRight = getStyleVal(col, "padding-right");
//     return parseInt(padLeft) + parseInt(padRight);
//   }

//   function getStyleVal(elm, css) {
//     return window.getComputedStyle(elm, null).getPropertyValue(css);
//   }
// };
